import { TweenEffect } from '.';
import { Component } from "../../helpers/compiler";

@Component({ className: 'js-tween-effect' })
export class TweenEffectComponent {

	constructor(private element: HTMLElement) {
		const hook = parseFloat(element.getAttribute('data-tween-effect-hook') || '');
		const offset = parseFloat(element.getAttribute('data-tween-effect-offset') || '');
		const duration = parseFloat(element.getAttribute('data-tween-effect-duration') || '');
		const delay = parseFloat(element.getAttribute('data-tween-effect-delay') || '');
		const stagger = parseFloat(element.getAttribute('data-tween-effect-stagger') || '');
		const individualScenes = element.getAttribute('data-tween-effect-individual-scenes') == 'true';

		new TweenEffect(element, {
			...(isNaN(hook) ? undefined : { hook: hook }),
			...(isNaN(offset) ? undefined : { offset: offset }),
			...(isNaN(duration) ? undefined : { duration: duration }),
			...(isNaN(delay) ? undefined : { delay: delay }),
			...(isNaN(stagger) ? undefined : { stagger: stagger }),
			...({ individualScenes: individualScenes }),
		})
	}
}
